import PropTypes from 'prop-types';
import React from 'react';
import { browserHistory } from 'react-router';

import JobForm from '../../components/job_form/JobForm.react';
import EditDetailHeader from './components/EditDetailHeader.react';
import { SavedJob } from '../../stores/SavedJobsStore';

const SavedJobForm = ({ savedJob }) => (
  <article className='saved-job-detail'>
    <EditDetailHeader
      onEditCancel={() => browserHistory.push(`/savedjobs/${savedJob.id}`)}
    />
    <JobForm savedJob={savedJob} />
  </article>
);

export default SavedJobForm;

SavedJobForm.propTypes = {
  savedJob: PropTypes.instanceOf(SavedJob),
};
